// extracted by mini-css-extract-plugin
export default {"welcomeImage":"_3Cis_y9e7dCA3jl3PVARx3","row":"KAbINjpESHEjYTZmeKXEI","span":"_1MljffYAk-3M0qxksgJEgw","helpIcon":"_2SdaVEUXFiP2fAzOcjY2E-","guideButton":"_1F3hW1W2VQCkK1U9Cd4-wX"};